import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError, formatCDF } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import MobileHeader from "../../components/MobileHeader";
import BottomNav from "../../components/BottomNav";
import { Card, StatusBadge } from "../../components/ui-kit";

export default function DriverHistory() {
  const { user } = useAuth();
  const workerRole = user?.role === "courier" ? "courier" : "driver";
  const [rides, setRides] = useState([]);

  useEffect(() => {
    api.get("/rides").then(({ data }) => setRides(data)).catch((e) => toast.error(formatApiError(e)));
  }, []);

  return (
    <div className="phone-frame phone-scroll-safe bg-premium-grad">
      <MobileHeader title="Courses" />
      <div className="space-y-3 px-4 pt-2">
        <h1 className="font-heading text-2xl font-bold">Mes courses</h1>
        {rides.length === 0 && (
          <Card className="p-8 text-center text-xs text-muted-foreground">Aucune course</Card>
        )}
        {rides.map((r) => (
          <Card key={r.id} className="p-3" data-testid={`drv-ride-${r.id}`}>
            <div className="flex items-center justify-between">
              <div>
                <div className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground">
                  #{r.id.slice(0, 6).toUpperCase()} · {new Date(r.created_at).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" })}
                </div>
                <div className="font-heading font-bold">{r.customer_name}</div>
                <div className="mt-1"><StatusBadge status={r.status} /></div>
              </div>
              <div className="font-mono text-base font-bold">{formatCDF(r.price * 0.8)}</div>
            </div>
          </Card>
        ))}
      </div>
      <BottomNav role={workerRole} />
    </div>
  );
}
